module.exports = "\r\n<nav class=\"leftsettingbox\">\r\n    <ul class=\"list-unstyled settinglist\">   \r\n           <li> \r\n               <a [routerLink]=\"['targetMaster']\" hasPermission=\"admin.target.targetMaster.active\"  routerLinkActive=\"selected\" ><section>&nbsp;&nbsp; Target</section></a>\r\n           </li>\r\n         \r\n    </ul>     \r\n</nav> \r\n<router-outlet></router-outlet>  "


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/target/target.component.html
// module id = ./src/app/admin/target/target.component.html
// module chunks = main